import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { Bell as NotificationsIcon, Menu as MenuIcon } from 'lucide-react';
import React from 'react';
import { signOut } from '../../services/auth';

const FirstBarGrid = styled('div')((p) => ({
  display: 'grid',
  gridTemplateColumns: 'min-content 1fr min-content min-content',
  width: '100%',
  marginLeft: p.theme.spacing(1.5),
  marginRight: p.theme.spacing(1.5)
}));

export default function Header(props: any) {
  const {
    adminUser,
    title,
    tabs,
    activeTabIndex,
    onChange,
    onDrawerToggle
  } = props;
  const theme = useTheme();

  return (
    <React.Fragment>
      <AppBar color="primary" position="static" elevation={0}>
        <Toolbar disableGutters>
          <FirstBarGrid>
            <div>
              <Hidden smUp>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  onClick={onDrawerToggle}
                  style={{ marginRight: theme.spacing() }}
                >
                  <MenuIcon />
                </IconButton>
              </Hidden>
            </div>

            <Typography
              color="inherit"
              variant="h5"
              style={{ alignSelf: 'center' }}
            >
              {title}
            </Typography>
            <div>
              <Tooltip title="Alerts • No alerts">
                <IconButton color="inherit">
                  <NotificationsIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div>
              <Tooltip title="Click to sign out">
                <IconButton
                  color="inherit"
                  style={{
                    marginLeft: theme.spacing()
                  }}
                  onClick={signOut}
                >
                  <Avatar src={adminUser.photoURL} />
                </IconButton>
              </Tooltip>
            </div>
          </FirstBarGrid>
        </Toolbar>
      </AppBar>
      {tabs.length > 0 && (
        <AppBar
          className={css({ zIndex: 0 })}
          color="primary"
          position="static"
          elevation={0}
        >
          <Tabs value={activeTabIndex} color="inherit" onChange={onChange}>
            {tabs.map((tab: string, i: number) => (
              <Tab color="inherit" label={tab} key={i} />
            ))}
          </Tabs>
        </AppBar>
      )}
    </React.Fragment>
  );
}
